/* globals $ */
import { registerClass } from 'libs/ComponentLoader'

import './styles.scss'

class UtilityMenu {
  constructor (element) {
    this.$el = $(element)

    this.$el.find('.utilityMenu-searchButton').on('click', (e) => {
      this.$el.find('.search-dropdown').toggleClass('u--hide')
    })
  }
}

registerClass('UtilityMenu', UtilityMenu)
